import request from '@/utils/request'
import qs from 'qs'
// 获取车辆管理列表
export function GetCarList(data) {
  return request({
    url: '/car/carInform/data',
    method: 'post',
    data
  })
}
// 获取排序方式列表
export function GetSortList() {
  return request({
    url: '/car/carInform/sortList',
    method: 'post'
  })
}
// 获取车辆详情
export function GetCarDetail(data) {
  return request({
    url: '/car/carInform/getDetail',
    method: 'post',
    data
  })
}
// 获取车辆历史报警列表
export function GetCarAlarmList(data) {
  return request({
    url: '/car/carInform/getCarAlarm',
    method: 'post',
    data
  })
}
// 获取车辆租赁信息列表
export function GetCarLeaseList(data) {
  return request({
    url: '/car/carInform/getCarLease',
    method: 'post',
    data
  })
}

// 新增
export function addCarInform(data) {
  return request({
    url: '/car/carInform/add',
    method: 'post',
    data
  })
}

// 编辑
export function editCarInform(data) {
  return request({
    url: '/car/carInform/setDetail',
    method: 'post',
    data
  })
}

// 车门
export function getCarDoor(data) {
  return request({
    url: '/car/carInform/getCarDoor',
    method: 'post',
    data
  })
}
// 忽略
export function getconfirm(data) {
  return request({
    url: '/car/alarm/confirm',
    method: 'post',
    data
  })
}


// 逻辑删除
export function deleteLogicCar(data) {
  return request({
    url: '/car/carInform/deleteUpdate',
    method: 'post',
    data
  })
}
// 查询所有可租赁用户
export function GetdataSelectCarUser(data) {
  return request({
    url: '/car/carInform/getCarUser',
    method: 'post',
    data
  })
}

// 根据Id获得车辆信息
export function GetCarDetailes(data) {
  return request({
    url: '/car/carInform/getDetailes',
    method: 'post',
    data
  })
}


// 根据车架号获得车辆记录信息
export function getCarLeaseByCarNum(data) {
  return request({
    url: '/car/carInform/getCarLeaseByCarNum',
    method: 'post',
    data
  })
}


// 记录表更新或者插入数据并更新car_manage表状态
export function UpdateCarLease(data) {
  return request({
    url: '/car/carInform/UpdateCarLease',
    method: 'post',
    data
  })
}

// 根据TBOX 获取当前里程数
export function queryCarMileage(data) {
  return request({
    url: '/data/queryCarMileage',
    method: 'post',
    data: qs.stringify(data)
  })
}


// 租赁续期
export function reNewCarLease(data) {
  return request({
    url: '/car/carInform/reNewCarLease',
    method: 'post',
    data
  })
}

//获取车辆状态记录
export function getCarOnOffLineData(data) {
  return request({
    url: '/data/onOff/getCarOnOffLineData',
    method: 'post',
    data
  })
}

//解绑
export function carUnbind(data) {
  return request({
    url: '/car/carInform/unbind',
    method: 'post',
    data
  })
}

//获取部门
export function getDepartment(data) {
  return request({
    url: '/car/carInform/getDepartment',
    method: 'get',
    params:data
  })
}

//移交车辆
export function transfer(data) {
  return request({
    url: '/car/carInform/transfer',
    method: 'post',
    data
  })
}

//车辆归属变更记录
export function getCarTransfer(data) {
  return request({
    url: '/car/carInform/getCarTransfer',
    method: 'get',
    params:data
  })
}
